/**
*  The current code was generated by internal;
*  The current language is es - español - 西语;
*  Build Date 2026/01/06
*/

(function () {
  'use strict';

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width:1279.98px)').matches;
  }

  function init(navRoot) {
    var trigger = navRoot.querySelector('.titan-navigator__logo');
    var mobilePanel = navRoot.querySelector('.titan-navigator__mobile');
    var arrow = navRoot.querySelector('.titan-navigator__arrow');

    if (!trigger || !mobilePanel || !arrow) return;

    var open = false;

    function sync() {
      if (!isMobile()) {
        open = false;
      }

      mobilePanel.classList.toggle('navigator_mobile_show', open);
      arrow.classList.toggle('svg-arrow-circle-bottom', open);
    }

    trigger.addEventListener('click', function () {
      if (!isMobile()) return;
      open = !open;
      sync();
    });

    window.addEventListener(
      'resize',
      function () {
        sync();
      },
      { passive: true }
    );

    sync();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var navigators = document.querySelectorAll('.titan-navigator');
    for (var i = 0; i < navigators.length; i++) {
      init(navigators[i]);
    }
  });
})();
